import classNames from "classnames"
import styles from "./styles.module.scss"
import { Popover } from "../../atoms/Popover"
import { makeAutoObservable } from "mobx"
import { useMemo } from "react"
// import AlertCircleOutline from "~icons/eva/alert-circle-outline"
import { observer } from "mobx-react-lite"

type PaymentRequestDetailsCardItem = {
  label: string
  value: string
  statusType?: string
  tooltip?: string
  testId?: string
}

class PaymentDetailsCardStore {
  openTooltip: string | null

  constructor() {
    this.openTooltip = null

    makeAutoObservable(this)
  }

  setOpenTooltip(value: string | null) {
    this.openTooltip = value
  }
}

export const PaymentRequestDetailsCard = observer(function PaymentRequestDetailsCard({
  items,
  total,
}: {
  items: PaymentRequestDetailsCardItem[]
  total?: PaymentRequestDetailsCardItem
}) {
  const store = useMemo(() => new PaymentDetailsCardStore(), [])

  return (
    <div className={styles.paymentRequestDetailsCard}>
      {items.map((item) => (
        <div className={styles.item} key={item.label}>
          <Popover
            isOpen={store.openTooltip === item.tooltip}
            wrapperClassName={styles.tooltipContent}
            content={<p>{item.tooltip}</p>}
            positions={["right"]}
            onClickOutside={() => store.setOpenTooltip(null)}
          >
            <div className={styles.label}>
              <p>{item.label}</p>
              {/* TODO add button if we add dropdown for manual status change
              {item.tooltip && (
                <button onClick={() => {
                  if (store.openTooltip === item.tooltip) {
                    store.setOpenTooltip(null)
                  } else {
                    store.setOpenTooltip(item.tooltip)
                  }
                }}>
                  <AlertCircleOutline className={styles.tooltipIcon} />
                </button>
              )} */}
            </div>
          </Popover>
          <p
            className={classNames(styles.value, item.statusType && styles[item.statusType])}
            data-testid={item.testId}
          >
            {item.value}
          </p>
        </div>
      ))}
      {total && (
        <>
          {items.length > 0 ? <div className={styles.divider} /> : null}
          <div className={styles.item}>
            <p className={styles.label}>{total.label}</p>
            <p className={classNames(styles.value, styles.valueTotal)}>{total.value}</p>
          </div>
        </>
      )}
    </div>
  )
})
